import { bff_client } from '@/lib/apiClient'
import { apiAgendor } from './api-client'

interface Contact {
  email?: string
  work?: string
  mobile?: string
  fax?: string
  whatsapp?: string
  facebook?: string
  twitter?: string
  instagram?: string
  linked_in?: string
  skype?: string
}

interface Address {
  postal_code: string
  country: string
  district: string
  state: string
  street_name: string
  street_number: number
  additional_info?: string
  city: number
}

export interface CreatePeopleAgendorRequest {
  name: string
  cpf?: string
  organization?: number
  role?: string
  ranking?: number
  description?: string
  birthday?: string
  ownerUser?: number
  contact?: Contact
  address?: Address
  leadOrigin?: number
  category?: number
  products?: number[]
  allowedUsers?: number[]
  allowToAllUsers?: boolean
  customFields?: {}
}

interface CreatePeopleAgendorResponse {
  data: Data
}

interface Data {
  id: number
  accountId: number
  name: string
  email: string
  organization: {
    id: string
    name: string
    email: string
  }
  cpf: string
  role: string
  ranking: number
  description: string
  birthday: string
  avatar: string
  createdAt: any
  updatedAt: any
  products: {
    id: number
    name: string
    code: string
    categoryId: number
    price: number
    active: boolean
    createdAt: any
  }[]
  contact: {
    email: string
    work: string
    mobile: string
    fax: string
    ramal: string
    radio: string
    whatsapp: string
    facebook: string
    twitter: string
    linkedIn: string
    skype: string
    instagram: string
  }
  address: {
    country: string
    district: string
    streetName: string
    streetNumber: number
    additionalInfo: string
    postalCode: string
    state: string
    city: string
  }
  category: {
    id: number
    name: string
  }
  leadOrigin: {
    id: number
    name: string
  }
  author: {
    accountId: number
    id: number
    name: string
  }
  ownerUser: {
    accountId: number
    id: number
    name: string
  }
  allowedUsers: {
    accountId: number
    id: number
    name: string
  }[]
  customFields: any
  _webUrl: string
}

export async function createPeopleAgendor(
  data: CreatePeopleAgendorRequest
): Promise<CreatePeopleAgendorResponse> {
  const response = await apiAgendor
    .post('people', {
      json: {
        ...data,
      },
    })
    .json<CreatePeopleAgendorResponse>()

  return response
}

export async function createPeople(
  data: CreatePeopleAgendorRequest
): Promise<CreatePeopleAgendorResponse> {
  const response = await bff_client
    .post('agendor/people', {
      json: {
        ...data,
      },
    })
    .json<CreatePeopleAgendorResponse>()

  return response
}
